import React, { useEffect, useState } from 'react';
import './TipsComponent.css'; // Asegúrate de tener el archivo CSS
import { TipsPrincipales } from '../../interfaces/TipsPrincipales.interface';
import { useApi } from '../../services/ApiServices';
import Loader from '../Loader.jsx';
import { useNavigate } from 'react-router-dom';
import { Grid2 } from '@mui/material';

const TipsComponent = () => {
  const { ApiRequest } = useApi();
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar el loader
  const [tips, setTips] = useState<TipsPrincipales[]>([]); // Inicializar como un array vacío
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSectionsToCook = async () => {
      try {
        setIsLoading(true);
        const data = await ApiRequest('api/Tips/ObtenerTipsPrincipales');

        setTips(data || []);
      } catch (error) {
        console.error('Error fetching tips:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSectionsToCook();
  }, [ApiRequest]);

  return (
    <>
    {isLoading ? (
      <Loader />
    ) : (
      <Grid2 container className="tips-container" spacing={2}>
        <Grid2 container className="tips-images" spacing={2}>
          {tips && tips.length > 0 && tips.map((tip, index) => {
            // Define el tamaño de las columnas dependiendo del índice
            const mdSize = index === 2 ? 6 : index === 3 ? 6 : 3;

            return (
              <Grid2 
                key={tip.id}
                size={{xs:12, md:mdSize}} // Ocupa un ancho dinámico en pantallas medianas
                onClick={() => navigate(`/tip/${tip.id}`)} 
                className="tip-item"
              >
                <img
                  src={tip.imagen}
                  alt={tip.titulo}
                  className="tip-image"
                  style={{
                    height: index === 3 ? '312px' : '536px', // Altura dinámica según el índice
                  }}
                />
                <Grid2 
                  className="tip-info" 
                  size={11}
                >
                  <h3 className="tip-title">{tip.titulo}</h3>
                  <p className="tip-description">
                    {tip.descripcion.length > 300 
                      ? `${tip.descripcion.substring(0, 300)}...` 
                      : tip.descripcion}
                  </p>
                </Grid2>
              </Grid2>
            );
          })}
          <Grid2 size={{xs:12, md:6}} className="tips-text">
          <p>Consulta nuestros más de 300 tips que te harán la vida más fácil</p>
          <button className="view-tips-button" onClick={() => navigate(`/tips`)}>Ver todos los tips</button>
        </Grid2>
        </Grid2>

        
      </Grid2>

    )}
    </>
  );
};

export default TipsComponent;
